import $ from 'jquery'
import SiteLocation from 'base/constants/site_location'
import LoginModal from 'desktop/containers/modals/login_modal'
import ReactDOM from 'react-dom'
import renderReduxComponent from 'base/lib/render_redux_component'
import routeTo from 'base/lib/route_to'

$(() =>
  $(document).on('click', '.login-prompt', event => {
    event.preventDefault()

    const onSuccess = () => {
      const nextUrl = $(event.currentTarget).data('href')

      if (nextUrl) {
        routeTo(nextUrl)
      }
    }

    renderReduxComponent(LoginModal, {
      container: $('.banner-container'),
      onRequestClose() {
        ReactDOM.unmountComponentAtNode($('.banner-container')[0])
      },
      onSignInSuccess: onSuccess,
      onSignUpSuccess: onSuccess,
      siteLocation: SiteLocation.COMING_SOON_WAITLIST,
    })
  }),
)
